(() => {
  function validate(schema, properties) {
    return schema.every(rule => {
      const value = String(properties[rule.key] || '');
      if (!value.trim()) return !rule.required;
      if (rule.type === 'text') {
        if (rule.script === 'latin' && !/^[A-Za-z ]+$/.test(value)) return false;
        const count = Array.from(value.replace(/\s/g, '')).length;
        return count >= (rule.minLength || 0) && (!rule.maxLength || count <= rule.maxLength);
      }
      // Jeweliful transmits the visible position (1..n), not the underlying font ID.
      if (rule.type === 'font') return /^[1-9]\d*$/.test(value) && Number(value) <= (rule.fonts || []).length;
      if (rule.options?.length) return rule.options.some(option => String(typeof option === 'object' ? option.value : option) === value);
      return true;
    });
  }
  function readLink(href, schema, variants) {
    try {
      const url = new URL(href), data = new URLSearchParams(url.hash.slice(1));
      if (!data.has('atelier')) return null;
      if (data.getAll('atelier').length !== 1 || data.get('atelier') !== '1') throw new Error('version');
      const quantity = Number(data.get('quantity')), variantId = url.searchParams.get('variant');
      if (!Number.isInteger(quantity) || quantity < 1 || quantity > 99 || !variants.some(v => String(v.id) === variantId)) throw new Error('selection');
      const properties = {};
      for (const [key,value] of data) {
        if (key === 'atelier' || key === 'quantity') continue;
        if (!schema.some(rule => rule.key === key) || data.getAll(key).length !== 1) throw new Error('field');
        properties[key] = value;
      }
      if (data.getAll('quantity').length !== 1 || !validate(schema,properties)) throw new Error('properties');
      return {variantId, quantity, properties};
    } catch (_) { return {invalid:true}; }
  }
  // Keep this launch catalog aligned with the Flow order validator.
  const supplierCatalog = {
    '15445303165115': {first:67941251285179,last:67941254398139,min:2,max:11,fonts:50},
    '15445174223035': {first:67940716282043,last:67940719395003,min:2,max:11,fonts:1},
    '15443773423803': {first:67914124296379,last:67914127409339,min:1,max:10,fonts:10,month:true},
    '15444832321723': {first:67939666198715,last:67939669311675,month:true},
    '15444859519163': {first:67939746087099,last:67939749200059},
    '15444867121339': {first:67939764404411,last:67939767517371}
  };
  const months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  const signs = ['Aries','Taurus','Gemini','Cancer','Leo','Virgo','Libra','Scorpio','Sagittarius','Capricorn','Aquarius','Pisces'];
  // Beleco pieces take their details from the order note, so each line must carry exactly the
  // fields Beleco's note asks for: 1–11 letters per name, a font number within the product's set
  // and, where asked, a birth month. The product and variant come from Shopify's own cart.
  const belecoCatalog = {
    '15437206257851': {names:['Name 1','Name 2'],fonts:30,month:true},
    '15437208486075': {names:['Name']},
    '15461899698363': {names:['Name'],fonts:30,month:true},
    '15461899862203': {names:['Name 1','Name 2'],fonts:30},
    '15461899894971': {names:['Name'],fonts:30,month:true},
    '15461899927739': {names:['Name'],fonts:30},
    '15461899960507': {names:['Name 1','Name 2'],fonts:30,month:true},
    '15461928239291': {names:['Name'],fonts:30},
    '15461928272059': {names:['Name'],fonts:30},
    '15461928304827': {names:['Name'],fonts:30,month:true},
    '15461928337595': {names:['Name']},
    '15461928370363': {names:['Name'],fonts:15},
    '15461928435899': {names:['Name'],anyScript:true},
    '15461928501435': {names:['Name'],fonts:30},
    '15461928632507': {names:['Name'],fonts:30},
    '15461928665275': {names:['Name'],fonts:30},
    '15461074632891': {names:['Name 1','Name 2']},
    '15461074731195': {names:['Name 1','Name 2']},
    '15461074796731': {names:['Name']},
    '15461074862267': {names:['Name 1','Name 2'],month:true},
    '15465558671547': {names:['Name'],anyScript:true,max:10},
    '15465558638779': {names:['Name'],anyScript:true,max:10,fonts:6},
    '15465558540475': {names:['Name'],fonts:30},
    '15465558442171': {dates:['Engraving']},
    '15465558409403': {names:['Name 1'],optional:['Name 2','Name 3','Name 4']},
    '15465558245563': {names:['Name 1','Name 2'],fonts:30},
    '15465558212795': {names:['Name']},
    '15465558147259': {names:['Name'],fonts:30},
    '15465558114491': {names:['Name']},
    '15465558048955': {names:['Name'],fonts:30},
    '15465695215803': {dates:['Engraving'],fonts:30},
    '15465695183035': {initials:['Initial']},
    '15465695084731': {names:['Name'],colors:['Enamel Color'],fonts:30},
    '15465695051963': {names:['Name'],fonts:30},
    '15465694953659': {names:['Name 1','Name 2']},
    '15465694888123': {names:['Name 1','Name 2','Name 3','Name 4']},
    '15465694363835': {names:['Name']},
    '15465693249723': {names:['Name 1','Name 2','Name 3','Name 4']},
    '15465692889275': {names:['Name'],fonts:30},
    '15465692856507': {dates:['Engraving'],fonts:30},
    '15465692823739': {names:['Name'],fonts:30},
    '15465692790971': {names:['Name'],fonts:30},
    '15465692627131': {names:['Name'],fonts:30},
    '15465692430523': {names:['Name'],fonts:30},
    '15465692266683': {names:['Name'],fonts:30},
    '15465692233915': {names:['Name 1','Name 2'],fonts:30},
    '15465692201147': {names:['Name'],fonts:30},
    '15465691414715': {names:['Name'],month:true},
    '15465691349179': {initials:['Initial'],month:true},
    '15465691316411': {names:['Name'],month:true},
    '15465691218107': {month:true},
    '15465691185339': {names:['Name 1','Name 2'],fonts:30,month:true},
    '15465690923195': {names:['Name'],fonts:30},
    '15465690235067': {names:['Name 1','Name 2'],fonts:30,month:true},
    '15465686171835': {zodiac:true},
    '15465685745851': {month:true},
    '15465685418171': {dates:['Engraving']},
    '15465685090491': {dates:['Engraving']},
    '15465684795579': {names:['Name'],colors:['Enamel Color'],fonts:30},
    '15465684435131': {names:['Name'],fonts:30},
    '15465684140219': {names:['Name'],fonts:30},
    '15465683779771': {initials:['Initial'],fonts:30},
    '15465683321019': {initials:['Initial'],fonts:30},
    '15465682829499': {initials:['Initial 1','Initial 2']},
    '15465682403515': {initials:['Initial'],fonts:30},
    '15465681911995': {names:['Name'],dates:['Date']},
    '15465680437435': {names:['Name 1'],optional:['Name 2','Name 3','Name 4']},
    '15465680011451': {names:['Name 1'],optional:['Name 2','Name 3','Name 4']}
  };
  function validateBelecoLine(item, rule) {
    if (!Number.isInteger(item.quantity) || item.quantity < 1 || item.quantity > 99) return false;
    const values = item.properties || {};
    if (values._auriani_note !== '1') return false;
    const letters = rule.anyScript ? /^[\p{L}][\p{L}\p{M} '.-]*$/u : /^[A-Za-z][A-Za-z '.-]*$/;
    const nameOk = key => {
      const name = String(values[key] || '').trim(), count = Array.from(name.replace(/ /g, '')).length;
      return letters.test(name) && count >= 1 && count <= (rule.max || 11);
    };
    // Optional names may be left out; a year or date to engrave takes digits or Roman numerals.
    if (!(rule.names || []).every(nameOk)) return false;
    if (!(rule.optional || []).every(key => !String(values[key] || '').trim() || nameOk(key))) return false;
    if (!(rule.dates || []).every(key => /^[0-9IVXLCDM][0-9IVXLCDM .\/-]{1,9}$/i.test(String(values[key] || '').trim()))) return false;
    // An initial is one Latin letter; an enamel colour is a plain colour word.
    if (!(rule.initials || []).every(key => /^[A-Za-z]$/.test(String(values[key] || '').trim()))) return false;
    if (!(rule.colors || []).every(key => /^[A-Za-z][A-Za-z -]{2,11}$/.test(String(values[key] || '').trim()))) return false;
    if (rule.fonts && (!/^[1-9]\d*$/.test(String(values.Font || '')) || Number(values.Font) > rule.fonts)) return false;
    if (rule.zodiac && !signs.includes(values['Zodiac Sign'])) return false;
    return !rule.month || months.includes(values['Birth Month']);
  }
  function validateSupplierCartLine(item) {
    const beleco = belecoCatalog[String(item?.product_id)];
    if (beleco) return validateBelecoLine(item, beleco);
    const rule = supplierCatalog[String(item?.product_id)];
    const variant = Number(item?.variant_id), rawVariant = String(item?.variant_id);
    if (!rule || !Number.isSafeInteger(variant) || String(variant) !== rawVariant || variant < rule.first || variant > rule.last || (variant-rule.first)%32768 !== 0) return false;
    if (!Number.isInteger(item.quantity) || item.quantity < 1 || item.quantity > 99) return false;
    const values = item.properties || {};
    if (rule.max) {
      const name = String(values.Name || ''), count = name.replace(/ /g,'').length;
      if (!/^[A-Za-z ]+$/.test(name) || count < rule.min || count > rule.max) return false;
      if (!/^[1-9]\d*$/.test(String(values.Font || '')) || Number(values.Font) > rule.fonts) return false;
    }
    return !rule.month || months.includes(values['Birth Month']);
  }
  const api = {validate,readLink,validateSupplierCartLine};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') window.AurianiPersonalization = api;
})();
